import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    BlockType,
    Setting,
    SettingType,
    Define,
    ValidationMessage,
    SettingState,
    TibboDataType,
    AppBlockPort,
} from '@appblocks/codegeneration/types';

export default class LogPair extends BaseFeature {
    constructor() {
        super();
        this.name = 'Log key-value';
        this.id = 'log_key_value';
        this.fileLinks = [

        ];

        const settings = [
            {
                id: 'NAME',
                name: 'Key',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
            {
                id: 'VALUE',
                name: 'Value',
                settingType: SettingType.STRINGVARIABLE,
                required: true,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    setSettingValue(id: string, value: any) {
        if (value.indexOf('=') >= 0 || value.indexOf(',') >= 0) {
            return;
        }
        super.setSettingValue(id, value);
    }

    getInputs(): AppBlockPort[] {
        const project = this.project;
        const parent = project.getParent(this);
        return parent.getInputs();
    }

    getOutputs(): AppBlockPort[] {
        const project = this.project;
        const parent = project.getParent(this);
        return parent.getOutputs();
    }

    validate(): Array<ValidationMessage> {
        const errors: Array<ValidationMessage> = [];
        return errors;
    }
}
